import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Kiosk from '../../api/controllers/Kiosk/Kiosk';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import SvgIcon from '../../common/SvgIcon/SvgIcon';
import Text from '../../common/Text/Text';
import useBooking from '../../hooks/useBooking/useBooking';
import useHotelConfig from '../../hooks/useHotelConfig/useHotelConfig';
import useToken from '../../hooks/useToken/useToken';
import './Home.scss';

const Home = () => {
  const { hotelConfiguration, setHotelConfiguration } = useHotelConfig();
  const { resetBooking } = useBooking();
  const { token } = useToken();
  const [error, setError] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    resetBooking();
    Kiosk.show()
      .then(configs => {
        setHotelConfiguration(JSON.stringify(configs));
      })
      .catch(() => {
        setError('');
      });
  }, [token, setHotelConfiguration, resetBooking]);

  const handleContinue = () => {
    navigate('/name') as void;
  };

  return (
    <div className="home">
      <img src={logo} className="logo" />
      {error ? <Text type="body">{error}</Text> : null}
      <div className="location">
        <Text type="body">You are at:</Text>
        <div className="information">
          <SvgIcon iconName="LocationDotSolid" fill="var(--primary)" height={23} width={23} />
          <Text type="header">
            {hotelConfiguration?.data?.address
              ? `${hotelConfiguration.data?.name ? `${hotelConfiguration.data?.name}, ` : ''}${hotelConfiguration?.data?.address}`
              : 'Unknown location'}
          </Text>
        </div>
      </div>
      <Button
        buttonStyleType="primary"
        label="Book a taxi"
        handleClick={handleContinue}
        customStyling={{ width: '100%', marginTop: '24px' }}
        disabled={!hotelConfiguration?.data || !!hotelConfiguration?.error}
      />
    </div>
  );
};

export default Home;
